import configService from './app-config.service';

const getSearch = async (authToken, searchString) => {
    try {
        const headers = new Headers();
        headers.append('Authorization', `Bearer ${authToken}`);

        const options = {
            method: 'GET',
            headers: headers
        };

        searchString = searchString.replace('/', '');
        const response = await fetch(`${configService.appConfig.apiUrl}/PortCode/Match/${searchString}`, options);

        if (!response.ok) {
            const message = `An error occurred: ${response.statusText}`;
            console.error(message);
            return;
        }

        const jsonData = await response.json();
        return jsonData;
    } catch (err) {
        return undefined;
    }
};

const getSearchCountryLookup = async (authToken, searchString) => {
    try {
        const headers = new Headers();
        headers.append('Authorization', `Bearer ${authToken}`);

        const options = {
            method: 'GET',
            headers: headers
        };

        searchString = searchString.replace('/', '');
        const response = await fetch(`${configService.appConfig.apiUrl}/PortCode/MatchCountryLookup/${searchString}`, options);

        if (!response.ok) {
            const message = `An error occurred: ${response.statusText}`;
            console.error(message);
            return;
        }

        const jsonData = await response.json();
        return jsonData;
    } catch (err) {
        return undefined;
    }
};

export default {
    getSearch,
    getSearchCountryLookup
};
